import { computed, inject } from "vue";
import type {
  IEmailsProviderData,
  IEmailsProviderMethods
} from "@/models/providers/emails";

/**
 * Composable to inject emailHistory provider data and methods.
 */
export function useEmailHistoryInjector() {
  const emailHistoryDataProvider = inject<() => IEmailsProviderData>(
    "emailHistoryProvider"
  );
  const emailHistoryMethodsProvider = inject<IEmailsProviderMethods>(
    "emailHistoryMethods"
  );

  if (!emailHistoryDataProvider || !emailHistoryMethodsProvider) {
    throw new Error("'emailHistoryProvider' was not provided");
  }

  const emailHistoryData = computed(() => emailHistoryDataProvider());

  return {
    emailHistoryData,
    emailHistoryMethods: emailHistoryMethodsProvider
  };
}
